type ShowcaseVariant = 'hero' | 'inline';

const projects = [
  {
    name: 'Cafe & Bar Luxor',
    url: 'https://cafebarluxor.com',
    image: '/manus-storage/luxor_screenshot_9c25a67e.jpg',
    className: 'ng-laptop-main',
  },
  {
    name: 'Villa Dorada Resort',
    url: 'https://www.villadorada.xyz',
    image: '/manus-storage/portfolio-villadorada_new_a0932779.webp',
    className: 'ng-laptop-top',
  },
  {
    name: 'Peak Auto Detailing',
    url: 'https://www.peakdetail.xyz',
    image: '/manus-storage/portfolio-peakdetail_new_710cd381.webp',
    className: 'ng-laptop-bottom',
  },
];

export default function NorthgateLaptopStack({ variant = 'hero' }: { variant?: ShowcaseVariant }) {
  return (
    <div className={`ng-laptop-stack ng-laptop-stack--${variant}`} aria-label="Selected Northgate Web projects">
      {projects.map((project, index) => (
        <a
          key={project.name}
          href={project.url}
          target="_blank"
          rel="noreferrer"
          className={`ng-laptop ${project.className}`}
          aria-label={`View ${project.name}`}
        >
          <div className="ng-laptop__screen">
            <img src={project.image} alt="" loading={index === 0 ? 'eager' : 'lazy'} decoding="async" />
          </div>
          <div className="ng-laptop__base" />
          <span className="ng-laptop__label">{project.name}</span>
        </a>
      ))}
    </div>
  );
}
